module.exports = __webpack_public_path__ + "img/profits.765903cd.webp";